/* eslint-disable */
import React from 'react';
import { useTranslation } from 'react-i18next';

//MUI Icons
import AttachFileIcon from '@mui/icons-material/AttachFile';

//Custom Components
import TableButton from './TableButton';

//Types
import { ITableActionButtonDetail } from '@/@types/ui/Table';
import { Badge } from '@mui/material';
import { DCRecord } from '@/@types/lib/dataController';

interface ITableButtonDocuments extends ITableActionButtonDetail {
  disabled?: boolean;
  badgeValue?: number;
  isEnabledRecord?: (selection: { [key: string]: DCRecord }) => boolean;
}

function TableButtonDocuments(props: ITableButtonDocuments) {
  const { t } = useTranslation();

  const { disabled, isEnabledRecord, badgeValue = 0 } = props;

  return (
    <Badge color="primary" badgeContent={badgeValue} showZero={false} sx={{ mr: '4px' }}>
      <TableButton
        isEnabledRecord={isEnabledRecord}
        allow={disabled ? 'none' : 'one'}
        startIcon={<AttachFileIcon />}
        selection={{}}
        variant="outlined"
        {...props}
      >
        {t('buttons.documents')}
      </TableButton>
    </Badge>
  );
}

export default TableButtonDocuments;
